import React from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  quote: 'Pensaba que mi problema era vender más. Después de aplicar las primeras fases descubrí que estaba perdiendo dinero por errores que ni siquiera veía. Hoy sé exactamente cuánto gano cada mes.',
  name: 'Martín G.',
  role: 'Dueño de Comercio'
}, {
  quote: 'Mi negocio facturaba bien, pero siempre estaba preocupado por la plata. Este método me ayudó a ordenar todo y a tener mucha más tranquilidad.',
  name: 'Carla M.',
  role: 'Emprendedora'
}, {
  quote: 'Lo mejor es que está explicado de forma simple. En pocas semanas pude organizar mis números y dejar de tomar decisiones a ciegas.',
  name: 'Sebastián R.',
  role: 'Profesional Independiente'
}];
export function Testimonials() {
  return <section className="py-20 bg-navy-50" data-id="element-367">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-368">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-369">
          <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-4" data-id="element-370">
            LO QUE DICEN QUIENES YA COMENZARON A IMPLEMENTAR EL MÉTODO
          </h2>
          <div className="w-24 h-1 bg-success mx-auto rounded-full" data-id="element-371"></div>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-372">
          {testimonials.map((testimonial, index) => <motion.div key={index} className="bg-white p-8 rounded-2xl shadow-lg border border-slate-100 flex flex-col h-full" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} data-id="element-373">
              <div className="flex text-yellow-400 mb-6 text-xl" data-id="element-374">
                {'★★★★★'.split('').map((star, i) => <span key={i} data-id="element-375">{star}</span>)}
              </div>
              <p className="text-slate-700 italic mb-8 flex-1 text-lg leading-relaxed" data-id="element-376">
                "{testimonial.quote}"
              </p>
              <div className="border-t border-slate-100 pt-4 mt-auto" data-id="element-377">
                <p className="font-bold text-navy-900" data-id="element-378">{testimonial.name}</p>
                <p className="text-sm text-slate-500" data-id="element-379">{testimonial.role}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}